export const routes = {
  Startpage: {path: '/'},
  MapShare: {path: '/share/:id'},
  PlaceDetails: {path: '/place/:lat/:lon'},
  AroundMe: {path: '/around-me'},
  MatchDetails: {path: '/match/:id'},
  Impressum: {path: '/impressum'},
};
